import { render, staticRenderFns } from "./WhatsNewHardCoded.vue?vue&type=template&id=4622bf15&"
import script from "./WhatsNewHardCoded.vue?vue&type=script&lang=js&"
export * from "./WhatsNewHardCoded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports